// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const UtcNoteMessage = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.charts.utcNoteMessage"
        description="Utc note message."
        defaultMessage="Insights dates are based on UTC Time Zone"
    />
);
UtcNoteMessage.displayName = "UtcNoteMessage";
